import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "el-upload__tip" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"word-break":"break-all","word-wrap":"break-word","white-space":"pre-wrap"} }
const _hoisted_4 = { key: 5 }
const _hoisted_5 = { key: 6 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { size: "small" }, "只能选择当前时间五分钟之后的时间点", -1)
const _hoisted_7 = { key: 0 }

import { APIUrl } from "@/requests";
import { ref, PropType } from 'vue';
import { Upload, InfoFilled } from '@element-plus/icons-vue';
import { fileUploadLabel, newTaskLabelMap, label2KeyMap, label2Placeholder, CreateTaskOption, OptionConstruction, selectOptionMap, optionsMapTypeMap,
  crontabIntervalType,
  crontabDailyType,
  crontabOnceType,
 } from '@/store/modules/task/types';
import { ElMessage, UploadInstance } from 'element-plus';
import { CreateTaskParam, taskAPI } from '@/api/task';
import { Base64 } from "js-base64";
import ParamSelector from '@/components/task/ParamSelector.vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
  name: "ParamSelector",
});

interface UploadData {
  projId: string,
  uid: string,
  type: number,
  payload: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  taskType: {
    type: Number,
    required: true,
  },
  projId: {
    type: String,
    required: true,
  },
  uid: {
    type: String,
    required: true,
  },
  itemProp: {
    type: String,
    required: true,
  },
  createTaskForm: {
    required: true,
    type: Object as PropType<any>,
  },
  contentList: {
    type: Array as PropType<CreateTaskOption[]>,
    required: true,
  },
  fileList: {
    type: Array as PropType<fileUploadLabel[]>,
    required: true,
  },
},
  setup(__props, { expose }) {

const props = __props;



const uploadRefs = ref<UploadInstance[]>([]);

const uploadData = ref<UploadData | null>(null);
const contentData = ref<string[]>([]);
const token = localStorage.getItem('at_l_token');
const headerObj = {
  Authorization: `Bearer ${token}`,
};

const disabledTime = (time: Date): boolean => {
  const now = new Date(new Date().getTime() + 5 * 60000); // 5min after
  if (time.getMonth() !== now.getMonth()) return time.getMonth() < now.getMonth()
  if (time.getDate() !== now.getDate()) {
    return time.getDate() < now.getDate()
  } else {
    if (time.getHours() === 0 && time.getMinutes() === 0 && time.getSeconds() === 0) return false
    if (time.getHours() !== now.getHours()) {
      return time.getHours() < now.getHours()
    } else {
      return time.getMinutes() <= now.getMinutes()
    }
  }
}

const handleSelectChange = (paramName: string) => {
  if (paramName === "runMode") {
    props.createTaskForm['chooseTime'] = ""
    if (props.createTaskForm['runMode'] === crontabDailyType) {
      props.createTaskForm['chooseTime'] = getDefaultTime()
    }
  }
}
const getDefaultTime = () => {
  const hours = new Date().getHours();
  const minutes = new Date().getMinutes();
  return `${hours}:${minutes}`;
}

const getTypeByParam = (paramType: string): string => {
  if (paramType === "map") {
    let name = props.itemProp.split('.')[props.itemProp.split('.').length - 1];
    let typeMap = optionsMapTypeMap.get(name)
    if (!typeMap) { return "input" }
    let type = typeMap[1].get(String(props.createTaskForm[typeMap[0]]))
    return type ? type : "input"
  }
  return paramType
}

const getOptionsByProp = (prop: string): OptionConstruction[] => {
  let options = selectOptionMap.get(prop);
  if (typeof (options) !== "undefined") {
    return options
  }
  return []
}

const getFileParamByType = (taskType: number): fileUploadLabel[] => {
  let paramList = newTaskLabelMap.get(taskType);
  if (typeof (paramList) !== "undefined") {
    return paramList[0];
  }
  return [];
}

const genChildrenOption = (param: CreateTaskOption): any => {
  let childForm: { [key: string]: string } = {}
  param.children.forEach((childParam) => {
    childForm[childParam.name] = ""
  })
  return childForm;
}

const getContentParamByType = (taskType: number): CreateTaskOption[] => {
  let paramList = newTaskLabelMap.get(taskType);
  if (typeof (paramList) !== "undefined") {
    return paramList[1];
  }
  return [];
};

const getContent = (param: CreateTaskOption, index: number): string => {
  let content = contentData.value[index]
  let placeholder = label2Placeholder.get(param.name)
  let defaultContent = placeholder === undefined ? "" : placeholder
  return content === undefined ? defaultContent : content
}

const getDefaultContent = (key: string): string => {
  const defaultValue = label2Placeholder.get(key)
  return defaultValue !== undefined ? defaultValue : ""
}
const TimeFormat = (type: number, timeOrigin: string): string => {
  if (type === crontabOnceType) {
    return new Date(timeOrigin).toISOString()
  } else if (type === crontabDailyType) {
    var currentDate = new Date();
    var [hours, minutes] = timeOrigin.split(":").map(Number);
    currentDate.setHours(hours, minutes, 0, 0);
    return currentDate.toISOString()
  } else if (type === crontabIntervalType) {
    return timeOrigin
  }
  return "0001-01-01T00:00:00Z"
}


const genPayload = (options: { [key: string]: any }): string => {
  let payload: { [key: string]: string | number } = {};
  Object.keys(options).forEach(key => {
    if (key === "chooseTime") {
      payload[key] = TimeFormat(options["runMode"], options[key])
    } else {
      if (typeof options[key] === 'string' || typeof options[key] === 'number') {
        payload[key] = options[key] ? options[key] : getDefaultContent(key)
      } else if (typeof options[key] === 'object') {
        payload[key] = genPayload(options[key])
      }
    }
  });
  return JSON.stringify(payload)
}

const submitCreateTask = async () => {
  uploadRefs.value.forEach((uploadRef, index) => {
    if (uploadRef) {  //file with options
      let payload = genPayload(props.createTaskForm)
      uploadData.value = { 'projId': props.projId, 'uid': props.uid, 'type': props.taskType, 'payload': payload }
      uploadRef.submit()
    }
  })

  if (getFileParamByType(props.taskType).length === 0 && getContentParamByType(props.taskType).length > 0) {  // msg
    let content = genPayload(props.createTaskForm)

    let msg: CreateTaskParam = {
      'projId': props.projId,
      'uid': props.uid,
      'type': props.taskType,
      'payload': Base64.encode(content),
    }
    try {
      await taskAPI.createTask(msg)
      ElMessage({
        message: '创建任务成功',
        type: 'success',
      })
    } catch (err) {
      ElMessage({
        message: '创建任务失败',
        type: 'error',
      })
    }
  }

}

expose({
  submitCreateTask
})


return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fileList, (param, index) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_form_item, {
          label: _unref(label2KeyMap).get(param.name) ? _unref(label2KeyMap).get(param.name) : param.name
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              ref_for: true,
              ref_key: "uploadRefs",
              ref: uploadRefs,
              action: _unref(APIUrl) + '/upload/saveAndUploadToMega',
              multiple: "",
              "with-credentials": "",
              "auto-upload": false,
              headers: headerObj,
              name: "uploadFileName",
              data: uploadData.value
            }, {
              tip: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (param.tip.length < 50)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(InfoFilled))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(param.tip), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_popover, {
                        key: 1,
                        width: 800,
                        trigger: "hover",
                        placement: "right"
                      }, {
                        reference: _withCtx(() => [
                          _createElementVNode("p", null, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(InfoFilled))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 查看文件上传格式要求 ")
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_3, _toDisplayString(param.tip), 1)
                        ]),
                        _: 2
                      }, 1024))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  icon: _unref(Upload),
                  type: "primary",
                  style: {"float":"left"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("选择文件")
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 2
            }, 1032, ["action", "data"])
          ]),
          _: 2
        }, 1032, ["label"])
      ]))
    }), 256)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contentList, (param, index) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_form_item, {
          prop: props.itemProp + '.' + param.name,
          label: _unref(label2KeyMap).get(param.name) ? _unref(label2KeyMap).get(param.name) : param.name,
          rules: param.rules
        }, {
          default: _withCtx(() => [
            (getTypeByParam(param.type) === 'input')
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: props.createTaskForm[param.name],
                  "onUpdate:modelValue": ($event: any) => ((props.createTaskForm[param.name]) = $event),
                  placeholder: _unref(label2Placeholder).get(param.name) ? _unref(label2Placeholder).get(param.name) : '请输入'
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
              : (getTypeByParam(param.type) === 'select')
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    modelValue: props.createTaskForm[param.name],
                    "onUpdate:modelValue": ($event: any) => ((props.createTaskForm[param.name]) = $event),
                    placeholder: _unref(label2Placeholder).get(param.name) ? _unref(label2Placeholder).get(param.name) : '请选择',
                    style: {"width":"500px"},
                    onChange: ($event: any) => (handleSelectChange(param.name))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOptionsByProp(param.name), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          value: item.value,
                          label: item.label,
                          disabled: item.disabled
                        }, null, 8, ["value", "label", "disabled"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"]))
                : (getTypeByParam(param.type) === 'radio')
                  ? (_openBlock(), _createBlock(_component_el_radio_group, {
                      key: 2,
                      modelValue: props.createTaskForm[param.name],
                      "onUpdate:modelValue": ($event: any) => ((props.createTaskForm[param.name]) = $event),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_button, {
                          label: genChildrenOption(param)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("是")
                          ]),
                          _: 2
                        }, 1032, ["label"]),
                        _createVNode(_component_el_radio_button, { label: 'false' }, {
                          default: _withCtx(() => [
                            _createTextVNode("否")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : (getTypeByParam(param.type) === 'dateTime')
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 3,
                        modelValue: props.createTaskForm[param.name],
                        "onUpdate:modelValue": ($event: any) => ((props.createTaskForm[param.name]) = $event),
                        type: "datetime",
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        format: "YYYY-MM-DD HH:mm",
                        placeholder: "请选择任务执行时间",
                        "disabled-date": disabledTime,
                        "default-time": new Date(new Date().setHours(0, 0, 59))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "default-time"]))
                    : (getTypeByParam(param.type) === 'time')
                      ? (_openBlock(), _createBlock(_component_el_time_picker, {
                          key: 4,
                          modelValue: props.createTaskForm[param.name],
                          "onUpdate:modelValue": ($event: any) => ((props.createTaskForm[param.name]) = $event),
                          placeholder: "请选择每日执行时间",
                          "value-format": "HH:mm",
                          format: "HH:mm"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (getTypeByParam(param.type) === 'inputNumber')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_el_input_number, {
                              modelValue: props.createTaskForm[param.name],
                              "onUpdate:modelValue": ($event: any) => ((props.createTaskForm[param.name]) = $event),
                              min: 2,
                              size: "small"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createTextVNode(" 小时 ")
                          ]))
                        : _createCommentVNode("", true),
            (getTypeByParam(param.type) === 'dateTime')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(InfoFilled))
                    ]),
                    _: 1
                  }),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["prop", "label", "rules"]),
        (param.children && (props.createTaskForm[param.name] !== 'false'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(ParamSelector, {
                projId: props.projId,
                uid: props.uid,
                taskType: props.taskType,
                itemProp: props.itemProp + '.' + param.name,
                createTaskForm: props.createTaskForm[param.name],
                fileList: [],
                contentList: param.children
              }, null, 8, ["projId", "uid", "taskType", "itemProp", "createTaskForm", "contentList"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ], 64))
}
}

})